<!-- eslint-disable max-len -->
<template>
  <div class="add-new-vp">
    <!-- Header -->
    <div class="add-new-vp-header">
      <div class="d-flex align-items-center">
        <img
          v-if="typeSelected === 'form'"
          :src="require('@/assets/automation/data_manager.svg')"
          class="icon-new-vp"
        >
        <img
          v-else-if="typeSelected === 'event'"
          :src="require('@/assets/automation/event.svg')"
          class="icon-new-vp"
        >
        <img
          v-else-if="typeSelected === 'function'"
          :src="require('@/assets/automation/function.svg')"
          class="icon-new-vp"
        >
        <img
          v-else-if="typeSelected === 'job' ||
          typeSelected === 'dedicated_job'"
          :src="require('@/assets/automation/job.svg')"
          class="icon-new-vp"
        >
        <img
          v-else
          :src="require('@/assets/automation/api.svg')"
          class="icon-new-vp"
        >
        <h4 class="title-modal-add-vp">{{ titleHeader }}</h4>
      </div>
      <p
        class="close-modal"
        @click="closeModal"
      >
        &times;
      </p>
    </div>

    <!-- Content -->
    <div class="add-new-vp-content">
      <b-form-group
        :class="{'error-input' : $v.dataAutomation.name.$error}"
        class="mb-2"
      >
        <label for="name"> Name </label>
        <j-input
          id="name"
          v-model="$v.dataAutomation.name.$model"
          :error-required="$v.dataAutomation.name.$error"
          placeholder="Enter name here"/>
      </b-form-group>

      <b-form-group
        :class="{'error-input' : $v.dataAutomation.description.$error}"
        class="mb-2"
      >
        <label for="description"> Description </label>
        <j-textarea
          v-model="$v.dataAutomation.description.$model"
          :error-required="$v.dataAutomation.description.$error"
          :max-length="255"
          placeholder="Enter description here"
        />
      </b-form-group>

      <b-form-group
        v-if="dataAutomation.object === 'form'"
        :class="{'error-input' : $v.dataAutomation.table_group.$error}"
        class="mb-2"
      >
        <label> Table Group </label>
        <j-single-select
          v-model="$v.dataAutomation.table_group.$model"
          :error-required="$v.dataAutomation.table_group.$error"
          :options="tableGroupOptions"
          placeholder="Select Table Group"
          value-format="object"
          label="name"/>
      </b-form-group>

      <b-form-group
        v-if="dataAutomation.object === 'form'"
        :class="{'error-input' : $v.dataAutomation.form.$error}"
        class="mb-2"
      >
        <label> Table </label>
        <j-single-select
          v-model="$v.dataAutomation.form.$model"
          :error-required="$v.dataAutomation.form.$error"
          :disabled="!dataAutomation.table_group"
          :options="tableOptions"
          :placeholder="'Select Table'"
          value-format="object"
          label="name"/>
      </b-form-group>

      <b-form-group
        v-if="dataAutomation.object === 'form'"
        :class="{'error-input' : $v.dataAutomation.event.$error}"
        class="mb-2"
      >
        <label> Event </label>
        <j-single-select
          v-model="$v.dataAutomation.event.$model"
          :error-required="$v.dataAutomation.event.$error"
          :options="eventOptions"
          placeholder="Event"/>
      </b-form-group>

      <b-form-group
        v-if="dataAutomation.object === 'webhook_v2' || dataAutomation.object === 'api_v2'"
        :class="{'error-input' : $v.dataAutomation.method.$error}"
        class="mb-2"
      >
        <label> Method </label>
        <j-single-select
          v-model="$v.dataAutomation.method.$model"
          :error-required="$v.dataAutomation.method.$error"
          :options="methodOptions"
          placeholder="Select"/>
      </b-form-group>

      <b-form-group
        v-if="dataAutomation.object === 'webhook_v2' || dataAutomation.object === 'api_v2'"
        :class="{'error-input' : $v.dataAutomation.url.$error}"
        class="mb-2"
      >
        <label> Url </label>
        <b-row>
          <b-col md="6">
            <div class="block-url">{{ url }}</div>
          </b-col>
          <b-col
            md="6"
            class="p__l--1">
            <j-input
              v-model="$v.dataAutomation.url.$model"
              :max-length="255"
              class="url-input"
              style="margin-left: -35px"/>
          </b-col>
        </b-row>
      </b-form-group>

      <b-form-group
        v-if="dataAutomation.object === 'event'"
        :class="{'error-input' : $v.dataAutomation.event_name.$error}"
        class="mb-2"
      >
        <label> Event Name </label>
        <j-single-select
          v-model="$v.dataAutomation.event_name.$model"
          :error-required="$v.dataAutomation.event_name.$error"
          :options="optionEventName"
          placeholder="Select"/>
      </b-form-group>

      <b-form-group
        v-if="dataAutomation.object === 'function'"
        :class="{'error-input' : $v.dataAutomation.function_name.$error}"
        class="mb-2"
      >
        <label> Function Name </label>
        <j-input
          v-model="$v.dataAutomation.function_name.$model"
          :error-required="$v.dataAutomation.function_name.$error"
          :max-length="255"
          placeholder="Only lowercase characters and underscore '_' are allowed, ex: name_function"/>
      </b-form-group>

      <b-form-group
        v-if="dataAutomation.object === 'job'"
        :class="{'error-input' : $v.dataAutomation.job_name.$error}"
        class="mb-2"
      >
        <label> Job Name </label>
        <j-input
          v-model="$v.dataAutomation.job_name.$model"
          :error-required="$v.dataAutomation.job_name.$error"
          :max-length="255"
          placeholder="Only lowercase characters and underscore '_' are allowed, ex: name_job"/>
      </b-form-group>

      <b-form-group
        v-if="dataAutomation.object === 'dedicated_job'"
        :class="{'error-input' : $v.dataAutomation.dedicated_job_name.$error}"
        class="mb-2"
      >
        <label> Dedicated Job Name </label>
        <j-input
          v-model="$v.dataAutomation.dedicated_job_name.$model"
          :error-required="$v.dataAutomation.dedicated_job_name.$error"
          :max-length="255"
          placeholder="Only lowercase characters and underscore '_' are allowed, ex: name_dedicated_job"/>
      </b-form-group>

      <div
        v-if="dataAutomation.object === 'job' || dataAutomation.object === 'dedicated_job'"
        class="warning-function d-flex align-items-center"
      >
        <img
          :src="require('@/assets/icon/warning.svg')"
          alt="warning"
        >
        <div class="d-flex flex-column">
          <span class="title">Information</span>
          <span>
            Object Job will always be asynchronous
          </span>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="add-new-vp-footer">
      <button
        class="button-border mr-2"
        @click="closeModal">
        Close
      </button>
      <button
        class="button-blue"
        @click="submitData">
        Create
      </button>
    </div>
  </div>
</template>

<script>
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import jwtDecode from 'jwt-decode';

export default {
  props: {
    typeSelected: {
      type: String,
      default: '',
    },
    tableGroupOptions: {
      type: Array,
      default: () => [],
    },
    optionEventName: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      dataAutomation: {
        name: null,
        description: null,
        object: null,
        form: null,
        event: null,
        method: null,
        url: null,
        event_name: null,
        function_name: null,
        job_name: null,
        table_group: null,
        dedicated_job_name: null,
      },
      tableOptions: [],
      eventOptions: [
        {
          id: 'record_created',
          text: 'Record Created',
        },
        {
          id: 'record_updated',
          text: 'Record Updated',
        },
        {
          id: 'record_deleted',
          text: 'Record Deleted',
        },
        {
          id: 'record_approved',
          text: 'Record Approved',
        },
        {
          id: 'record_rejected',
          text: 'Record Rejected',
        },
        {
          id: 'record_submitted',
          text: 'Record Submitted',
        },
        {
          id: 'record_exported',
          text: 'Record Exported',
        },
        {
          id: 'record_closed',
          text: 'Record Closed',
        },
      ],
      methodOptions: [
        {
          id: 'post',
          text: 'POST',
        },
        {
          id: 'get',
          text: 'GET',
        },
        {
          id: 'delete',
          text: 'DELETE',
        },
      ],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },

  computed: {
    titleHeader() {
      let title = '';
      switch (this.typeSelected) {
        case 'form':
          title = 'Data Manager';
          break;
        case 'webhook':
          title = 'Webhook';
          break;
        case 'webhook_v2':
          title = 'Webhook';
          break;
        case 'api':
          title = 'API';
          break;
        case 'api_v2':
          title = 'API';
          break;
        case 'event':
          title = 'Event';
          break;
        case 'function':
          title = 'Function';
          break;
        case 'job':
          title = 'Job';
          break;
        case 'dedicated_job':
          title = 'Dedicated Job';
          break;
        default:
          title = '';
      }

      return title;
    },

    url() {
      const type = this.dataAutomation.object;

      if (type === 'api_v2') return `${process.env.URL_API_V2}${this.session.user.company_id}/`;
      else if (type === 'webhook_v2') return `${process.env.URL_WEBHOOK_V2}${this.session.user.company_id}/`;
      return `${process.env.GATE_URL}nocode/${type}/`;
    },
  },

  watch: {
    // eslint-disable-next-line
    'dataAutomation.function_name': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.dataAutomation.function_name =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'dataAutomation.job_name': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.dataAutomation.job_name =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'dataAutomation.dedicated_job_name': function (val){
      const regexSymbol = /[^\w\s]/g;
      setTimeout(() => {
        this.dataAutomation.dedicated_job_name =
          val.toLowerCase()
            .replace(regexSymbol, '')
            .replace(' ', '_');
      }, 1);
    },

    // eslint-disable-next-line
    'dataAutomation.table_group': function (val) {
      this.dataAutomation.form = null;
      setTimeout(() => { this.$v.dataAutomation.$reset(); }, 500);
      if (val) {
        const reqTable = {
          tablegroup_id: val.id,
          search: '',
        };
        this.getListTableByGroupV2(reqTable).then((res) => {
          if (!res.error) {
            this.tableOptions = res.data || [];
          }
        });
      }
    },
  },

  created() {
    if (this.typeSelected) this.dataAutomation.object = this.typeSelected;
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),
    ...mapActions('jStoreAutomation', ['createAutomationCode']),
    ...mapActions('jStoreForm', ['getListTableByGroupV2']),

    closeModal() {
      this.$emit('close-modal');
      this.dataAutomation = {
        name: null,
        object: null,
        form: null,
        event: null,
        method: null,
        url: null,
        event_name: null,
        function_name: null,
        job_name: null,
        table_group: null,
        dedicated_job_name: null,
      };
    },

    submitData() {
      this.$v.dataAutomation.$touch();
      if (!this.$v.dataAutomation.$error) {
        let dataForm = {};
        if (this.dataAutomation.object === 'form') {
          dataForm = {
            event: this.dataAutomation.event,
            tablegroup_id: this.dataAutomation.table_group.id,
            form_data_id: this.dataAutomation.form.id,
          };
        }
        let dataWebhook = {};
        if (this.dataAutomation.object === 'webhook_v2') {
          dataWebhook = {
            method: this.dataAutomation.method,
            url: this.dataAutomation.url,
            content_type: null,
            header: null,
          };
        }
        let dataApi = {};
        if (this.dataAutomation.object === 'api_v2') {
          dataApi = {
            method: this.dataAutomation.method,
            url: this.dataAutomation.url,
          };
        }
        let dataEvent = {};
        if (this.dataAutomation.object === 'event') {
          dataEvent = {
            name: this.dataAutomation.event_name,
          };
        }
        let dataFunction = {};
        if (this.dataAutomation.object === 'function') {
          dataFunction = {
            name: this.dataAutomation.function_name,
          };
        }
        let dataJob = {};
        if (this.dataAutomation.object === 'job') {
          dataJob = {
            name: this.dataAutomation.job_name,
          };
        }
        let dataDedicatedJob = {};
        if (this.dataAutomation.object === 'dedicated_job') {
          dataDedicatedJob = {
            name: this.dataAutomation.dedicated_job_name,
          };
        }
        const dataTrigger = {
          type: this.dataAutomation.object,
          form: dataForm,
          container_variable: null,
          container_response: null,
          scheduler: null,
          webhook_v2: dataWebhook,
          api_v2: dataApi,
          event: dataEvent,
          function: dataFunction,
          job: dataJob,
          dedicated_job: dataDedicatedJob,
        };
        const data = {
          id: '',
          name: this.dataAutomation.name,
          description: this.dataAutomation.description,
          is_active: true,
          is_sync: false,
          trigger: dataTrigger,
          actions: null,
        };
        this.createAutomationCode(data).then((response) => {
          if (!response.error) {
            this.$router.push(`/visual-programming/${response.data.id}`);
          } else {
            this.toggleProblem(response.message);
          }
        });
      }
    },
  },

  validations() {
    return {
      dataAutomation: {
        name: {
          required,
        },
        description: {},
        object: {
          required,
        },
        form: {
          required: requiredIf(() => this.dataAutomation.object === 'form'),
        },
        table_group: {
          required: requiredIf(() => this.dataAutomation.object === 'form'),
        },
        event: {
          required: requiredIf(() => this.dataAutomation.object === 'form'),
        },
        method: {
          required: requiredIf(() => this.dataAutomation.object === 'webhook_v2' || this.dataAutomation.object === 'api_v2'),
        },
        url: {
          required: requiredIf(() => this.dataAutomation.object === 'webhook_v2' || this.dataAutomation.object === 'api_v2'),
        },
        event_name: {
          required: requiredIf(() => this.dataAutomation.object === 'event'),
        },
        function_name: {
          required: requiredIf(() => this.dataAutomation.object === 'function'),
        },
        job_name: {
          required: requiredIf(() => this.dataAutomation.object === 'job'),
        },
        dedicated_job_name: {
          required: requiredIf(() => this.dataAutomation.object === 'dedicated_job'),
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/visual-programming/popup/jPopupAddNew.vue